import React from "react";
import PropTypes from "prop-types";
import Modal from "../modal";
import { Box, Text, VStack } from "native-base";
import { Link } from "react-router-dom";
import routes from "../../routes";
import colors from "../../constants/colors";

function QuotationErrorModal(props) {
  const { isOpen, onRequestClose } = props;

  return (
    <Modal isOpen={isOpen}>
      <VStack paddingX={10} paddingY={8} space={5} alignItems="center">
        <Text textAlign="center" fontSize="lg">
          No contamos con bases cercanas por lo que un Ejecutivo te va a
          contactar para dar seguimiento a tu solicitud de cotización.
        </Text>
        <VStack alignItems="center">
          <Text>Carmen Montserrat Martinez Uriarte</Text>
          <a href="mailto:soporteautotur@mobilityado.com">
            <Text color="blue.700" underline>
              soporteautotur@mobilityado.com
            </Text>
          </a>
          <a href="tel:+525551331100">
            <Text color="blue.700" underline>
              55 5133 1100 ext 8457
            </Text>
          </a>
        </VStack>
        <Link to={routes.experienceCreation} onClick={onRequestClose}>
          <Box
            backgroundColor={colors.primary}
            paddingY={3}
            paddingX={100}
            borderRadius="full">
            <Text color={colors.white}>Continuar</Text>
          </Box>
        </Link>
      </VStack>
    </Modal>
  );
}

QuotationErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default React.memo(QuotationErrorModal);
